export const IconInstagramColored20: {
  name: 'icon_instagram_colored_20-71cf4ed4b464'
} = {
  name: 'icon_instagram_colored_20-71cf4ed4b464'
}
